import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {ThreadType} from 'nutshell-graphql-types';
import type {
    UpdateInboundFacebookRules as UpdateInboundFacebookRulesMutation,
    UpdateInboundFacebookRulesVariables as UpdateInboundFacebookRulesMutationVariables,
    InboundFacebookRulesUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_INBOUND_FACEBOOK_RULES from '../mutations/update-inbound-facebook-rules.graphql';

export const useUpdateInboundFacebookRules = (
    threadType: ThreadType
): {
    updateInboundFacebookRules: (input: InboundFacebookRulesUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateInboundFacebookRules, {loading, error}] = useMutation<
        UpdateInboundFacebookRulesMutation,
        UpdateInboundFacebookRulesMutationVariables
    >(UPDATE_INBOUND_FACEBOOK_RULES);

    return {
        updateInboundFacebookRules: (input: InboundFacebookRulesUpdateInput) => {
            input.threadType = threadType;

            return updateInboundFacebookRules({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
